export default "__VITE_ASSET__b4129c01__"